import {
  BraidsImage,
  EyelashesImage,
  HaircutImage,
  KidsImage,
  LocsImage,
  MensHaircutImage,
  NailsImage,
  NaturalHairImage,
  SilkPressImage,
  WeavesImage,
} from './Constants';

import { ISearchTile } from '../SearchTile/SearchTile.types';

export const tiles: ISearchTile[] = [
  {
    source: BraidsImage,
    text: 'Braids',
    searchParams: { q: 'braids' },
  },
  {
    source: NaturalHairImage,
    text: 'Natural Hair',
    searchParams: { q: 'natural hair' },
  },
  {
    source: HaircutImage,
    text: 'Haircut',
    searchParams: { q: 'haircut' },
  },
  {
    source: MensHaircutImage,
    text: 'Men\'s Haircut',
    searchParams: { q: 'mens haircut' },
  },
  {
    source: LocsImage,
    text: 'Locs',
    searchParams: { q: 'locs' },
  },
  {
    source: SilkPressImage,
    text: 'Silk Press',
    searchParams: { q: 'silk press' },
  },
  {
    source: WeavesImage,
    text: 'Weaves',
    searchParams: { q: 'weaves' },
  },
  {
    source: EyelashesImage,
    text: 'Eyelashes',
    searchParams: { q: 'eyelash-extensions' },
  },
  {
    source: NailsImage,
    text: 'Nails',
    searchParams: { q: 'acrylic-nails' },
  },
  // Note: The tile below is shown on desktop only in most instances
  {
    source: KidsImage,
    text: 'Kids',
    searchParams: { q: 'kids' },
  },
];
